<template>
  <div class="page-wrap request-details-page">
    <div class="request-details-shell">
      <div class="request-details-topbar">
        <BaseButton variant="secondary" size="sm" @click="goBack">
          <BaseIcon name="arrow-right" class="request-details-back-icon" />
          Назад
        </BaseButton>
      </div>

      <section class="request-details-hero glass">
        <div>
          <div class="request-details-hero__eyebrow">Детали брони</div>
          <h1>{{ orderTitle }}</h1>
          <p>Клуб, место, дата, время и оплата без лишних блоков.</p>
        </div>

        <StatusBadge v-if="order" :status="order.status" />
      </section>

      <BaseCard v-if="order" class="request-details-card">
        <div class="booking-ticket">
          <div class="booking-ticket__main">
            <div class="booking-ticket__club">
              <span class="booking-ticket__icon">
                <BaseIcon name="home" />
              </span>
              <div>
                <span>Клуб</span>
                <strong>{{ order.club_name || '—' }}</strong>
              </div>
            </div>

            <div class="booking-ticket__seat">
              <span>Место</span>
              <strong>{{ order.seat_label || '—' }}</strong>
            </div>
          </div>

          <div class="booking-ticket__price">
            <span>Стоимость</span>
            <strong>{{ formatPrice(order.total_price || 0) }}</strong>
          </div>
        </div>

        <div class="details-compact-grid">
          <div class="details-chip">
            <BaseIcon name="calendar" />
            <span>Дата</span>
            <strong>{{ formatDate(order.booking_date) }}</strong>
          </div>

          <div class="details-chip">
            <BaseIcon name="clock" />
            <span>Время</span>
            <strong>
              {{ formatTime(order.start_time) }}
              <template v-if="order.end_time"> — {{ formatTime(order.end_time) }}</template>
            </strong>
          </div>

          <div class="details-chip">
            <BaseIcon name="users" />
            <span>Игроков</span>
            <strong>{{ order.guest_count || 1 }}</strong>
          </div>

          <div class="details-chip">
            <BaseIcon name="wallet" />
            <span>Оплата</span>
            <strong>{{ order.payment_status_label || paymentMeta(order.payment_status) }}</strong>
          </div>
        </div>

        <div class="details-info-block">
          <div class="details-info-block__row">
            <span>Номер брони</span>
            <strong class="details-info-block__number">{{ prettyOrderNumber }}</strong>
          </div>

          <div v-if="order.comment" class="details-info-block__row details-info-block__row--text">
            <span>Комментарий</span>
            <strong>{{ order.comment }}</strong>
          </div>
        </div>
      </BaseCard>

      <BaseCard v-else class="request-details-loading">
        Загрузка...
      </BaseCard>
    </div>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue';
import BaseCard from '../components/ui/BaseCard.vue';
import BaseIcon from '../components/ui/BaseIcon.vue';
import StatusBadge from '../components/ui/StatusBadge.vue';
import { formatDate, formatPrice, formatTime, paymentMeta } from '../utils/formatters';

export default {
  name: 'RequestDetailsView',
  components: {
    BaseButton,
    BaseCard,
    BaseIcon,
    StatusBadge,
  },
  data() {
    return {
      statusForm: {
        status: 'created',
        payment_status: 'not_paid',
        admin_comment: '',
      },
    };
  },
  computed: {
    order() {
      return this.$store.getters['orders/current'];
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    updatingStatus() {
      return this.$store.getters['orders/updatingStatus'];
    },
    prettyOrderNumber() {
      const raw = String(this.order?.order_number || '').trim();
      if (!raw) return '—';

      const match = raw.match(/(\d{4,})$/);
      return match ? `#${match[1]}` : raw;
    },
    orderTitle() {
      return this.prettyOrderNumber !== '—' ? this.prettyOrderNumber : 'Бронь';
    },
  },
  async mounted() {
    const result = await this.$store.dispatch('orders/fetchOrder', this.$route.params.orderNumber);

    if (result?.order) {
      this.statusForm = {
        status: result.order.status || 'created',
        payment_status: result.order.payment_status || 'not_paid',
        admin_comment: result.order.admin_comment || '',
      };
    }
  },
  methods: {
    formatDate,
    formatPrice,
    formatTime,
    paymentMeta,
    goBack() {
      this.$router.push('/requests');
    },
    async saveStatus() {
      if (!this.order) return;

      await this.$store.dispatch('orders/updateStatus', {
        order_number: this.order.order_number,
        ...this.statusForm,
      });
    },
  },
};
</script>

<style scoped src="./RequestDetailsView.css"></style>